var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"Xterminate",staticClass:"text-justify transparent"},[_c('h1',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t("portfolio.xterminate.pageLabel")))]),_c('hr',{staticClass:"primary"}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }